// extracted by mini-css-extract-plugin
export default {"contests-btn":"ToggleContests_contests-btn__ivRsV"};